import { type QueryKey, type UseQueryOptions, type UseQueryResult, useQuery as useQueryOriginal } from "react-query";

import { useRegisterQueries } from "./use-register-queries";

export function useQuery<
	TQueryFnData = unknown,
	TError = unknown,
	TData = TQueryFnData,
	TQueryKey extends QueryKey = QueryKey,
>(options: UseQueryOptions<TQueryFnData, TError, TData, TQueryKey>): UseQueryResult<TData, TError> {
	useRegisterQueries(options.queryKey ? [options.queryKey] : []);

	return useQueryOriginal(options);
}
